<template>
  <div class="">
    <wizard-page-header :stepTitle="stepTitle" :readonly="readonly"></wizard-page-header>

    <div class="content-container" :class="[readonly && 'opacity-70 pointer-events-none']">
      <a-spin :spinning="submitting">
        <a-row>
          <a-col :lg="6" :xs="0">
            <new-order-sidebar
              :stopAfterStep="1"
              :onAddedInstrument="onAdded"
              :canAdd="true"
              :order_items="$store.state.order.order_items"
              :readonly="readonly"
            />
          </a-col>
          <a-col :lg="18" :xs="24" class="px-4 pb-16">
            <h2 class="hidden mb-10 text-2xl md:block">{{ contentTitle }}</h2>
            <a-card
              v-for="order_item in $store.state.order.order_items"
              :key="order_item.id"
              class="mb-8"
            >
              <h2 class="text-xl font-bold text-white" slot="title">
                {{ order_item.item_name_copy }}
              </h2>

              <div
                slot="extra"
                class="flex items-center justify-center w-12 h-12 rounded-full cursor-pointer bg-i4m-orange-dark"
                @click="removeInstrument(order_item.id)"
              >
                <svgicon name="trash" color="white" height="24" width="24"></svgicon>
              </div>

              <a-form :form="form" @submit="handleSubmit">
                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['1'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-1`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['1'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['1'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12" v-if="order_item.item.maker">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">Liutaio / Produttore</label>
                      <a-input
                        v-decorator="[
                          `${order_item.id}#luthier`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        class="mt-4"
                        formErrors
                        placeholder=""
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :sm="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">Modello</label>
                      <a-input
                        v-decorator="[
                          `${order_item.id}#model`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        class="mt-4"
                        formErrors
                        placeholder=""
                      />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :xs="24" :sm="12">
                    <a-form-item
                      :colon="false"
                      :has-feedback="!!pricesErrors[order_item.id]"
                      :validate-status="pricesErrors[order_item.id] ? 'error' : ''"
                      :help="pricesErrors[order_item.id]"
                    >
                      <label class="font-bold" slot="label">Valore</label>
                      <div class="flex items-center mt-4">
                        <CurrencyInput
                          currency="EUR"
                          :distraction-free="false"
                          v-model="prices[order_item.id]"
                          :class="[
                            'price-input',
                            pricesErrors[order_item.id] && 'price-input-error'
                          ]"
                          inputmode="decimal"
                          :valueRange="{ min: 1 }"
                          :allowNegative="false"
                        />
                        <a-tooltip
                          slot="suffix"
                          title="Il valore del bene dovrà essere verificato durante il processo di acquisto tramite il caricamento di perizie di esperti"
                        >
                          <a-icon
                            :style="{ fontSize: '1.25rem' }"
                            class="ml-4 cursor-pointer"
                            type="info-circle"
                            style="color: rgba(0,0,0,.45)"
                          />
                        </a-tooltip>
                      </div>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row></a-row>
              </a-form>
            </a-card>

            <add-instrument-mobile-btn
              :stopAfterStep="1"
              :onAddedInstrument="onAdded"
              :canAdd="true"
              :readonly="readonly"
            />
          </a-col>
        </a-row>
      </a-spin>
    </div>

    <div
      class="fixed bottom-0 left-0 flex items-center justify-end w-full p-4 bg-white border-t border-gray-200"
    >
      <a-button
        type="primary"
        class="big"
        @click="handleSubmit"
        :loading="submitting"
        v-if="$store.state.order.order_items.length > 0"
      >
        {{ $t('cart.nextStep') }}
      </a-button>
    </div>
  </div>
</template>
<script>
import api from '@/api.js';
import questions from '@/questions.js';

export default {
  name: 'instruments',

  data() {
    let prices = {};

    this.$store.state.order.order_items.forEach(item => {
      prices[item.id] = 0;
    });

    return {
      currentStep: 0,
      stepTitle: this.$t('cart.title'),
      contentTitle: '1. I tuoi strumenti',
      form: this.$form.createForm(this, { name: 'instruments' }),
      questions,
      prices,
      pricesErrors: {},
      removingOrderItem: false,
      submitting: false
    };
  },
  computed: {
    readonly() {
      return !!this.$store.state.order.chosen_offer;
    },

    instrumentIds() {
      if (!this.$store.state.order || !this.$store.state.order.order_items) {
        return [];
      }

      return this.$store.state.order.order_items.map(i => i.id);
    },

    mobile: function() {
      return this.$mq.resize && this.$mq.below('768px');
    }
  },

  mounted() {
    this.$store.state.order.order_items.forEach(order_item => {
      const id = order_item.id;

      this.form.setFieldsValue({
        [`${id}#survey-1`]: order_item.survey ? order_item.survey[1] : null,
        [`${id}#luthier`]: order_item.luthier,
        [`${id}#model`]: order_item.model
      });

      this.prices[id] = parseFloat(order_item.value);
    });
  },

  methods: {
    async onAdded(itemId) {
      try {
        await api.addOrderItem(itemId);
      } catch (e) {
        this.$notification.error({
          message: "C'è stato un errore nell'inserimento dello strumento nel carrello. Contattaci!",
          duration: 300
        });
        return;
      }

      await this.$store.dispatch('getOrder', true);
    },

    handleSubmit() {
      if (this.readonly) {
        return this.$router.push({ name: 'questionnaire' });
      }

      this.submitting = true;

      // abilito gli errori
      let hasErrors = false;

      let pricesErrors = {};
      for (let id of this.instrumentIds) {
        if (!this.prices[id] || this.prices[id] <= 1) {
          hasErrors = true;
          pricesErrors[id] = 'Valore obbligatorio di almeno 1€';
        }
      }
      this.pricesErrors = pricesErrors;

      this.form.validateFieldsAndScroll(
        { scroll: { offsetTop: 30, alignWithTop: true } },
        async (err, values) => {
          if (err) {
            console.log('Form is invalid: ', values);
            this.submitting = false;
            return;
          }
          if (!hasErrors) {
            // let pricesErrors = {};
            // for (let id of this.instrumentIds) {
            //   if (!this.prices[id] || this.prices[id] <= 0) pricesErrors[id] = "E' obbligatorio";
            // }
            // this.pricesErrors = pricesErrors;

            let valuesPerInstrument = {};

            Object.keys(values).forEach(fieldId => {
              let [instrumentId, fieldName] = fieldId.split('#');

              if (!valuesPerInstrument[parseInt(instrumentId)]) {
                valuesPerInstrument[parseInt(instrumentId)] = { survey: {} };
              }

              // add extra-ant components values (e.g. VueCurrency)
              valuesPerInstrument[parseInt(instrumentId)].value = this.prices[instrumentId];

              // handle properly survey's fields
              if (fieldName.includes('survey')) {
                let [, questionId] = fieldName.split('-');
                valuesPerInstrument[parseInt(instrumentId)].survey[questionId] = values[fieldId];
              } else {
                valuesPerInstrument[parseInt(instrumentId)][fieldName] = values[fieldId];
              }
            });

            // Update each orderItem with a single call
            for (let id of Object.keys(valuesPerInstrument)) {
              try {
                await api.updateOrderItem(id, valuesPerInstrument[id]);
              } catch (error) {
                hasErrors = true;
                const errors = error.response.data.errors;
                for (let field in errors) {
                  this.form.setFields({
                    [`${id}#${field}`]: { errors: [new Error(errors[field][0])] }
                  });
                }
                console.log('error updating order item', error);
              }
            }
            await this.$store.dispatch('getOrder', true);

            this.submitting = false;
            if (hasErrors) return;

            this.$router.push({ name: 'questionnaire' });
          } else {
            this.submitting = false;
            return;
          }
        }
      );
    },

    async removeInstrument(id) {
      this.$confirm({
        title: this.$t('msg.sureremove'),
        onOk: async function() {
          this.removingOrderItem = true;
          const r = await api.removeOrderItem(id);
          const updatedOrder = await this.$store.dispatch('getOrder', true);
          this.removingOrderItem = false;

          if (updatedOrder.order_items.length === 0) {
            // if has no more instruments, take the user back to the home
            return this.$router.push({ name: 'home' });
          }

          if (!r) {
            this.$notification.error({
              message: this.$t('msg.somethingwrong'),
              duration: 5
            });
          }

          return r;
        }.bind(this),
        onCancel() {}
      });
    }
  }
};
</script>
